import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=3f38cc4c"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"
import style0 from "./ShowForm.vue?vue&type=style&index=0&id=3f38cc4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports